import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.component('blog-post', {
  props: ['title'],
  template: `
    <div>
      <h3>
        {{ title }}
      </h3>
    </div>p
  `
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
